'use strict'

import { apiInstance } from './index'

export class FetchEntregaClient {
  static fetchEntrega = config => {
    config.baseURL = process.env.VUE_APP_API_RIDE_URL
    return new Promise((resolve, reject) => {
      apiInstance(config)
        .then(res => {
          const errno = res.data.errno
          if (String(errno) === '0') {
            resolve(res)
          } else {
            FetchEntregaClient.dealErrhandle({
              resolve,
              reject,
              config,
              err: res.data
            })
          }
        })
        .catch(err => {
          FetchEntregaClient.dealErrhandle({
            resolve,
            reject,
            config,
            err: err
          })
        })
    })
  };

  /**
   * 错误统一处理
   */
  static dealErrhandle (params) {
    const { resolve, reject, config, err } = params
    /* 错误处理方式 */
    if (config.errHandleType === ErrHandleType.deal_nothrow) {
      FetchEntregaClient.dealErrCode(err)
      resolve(err)
    } else if (config.errHandleType === ErrHandleType.nodeal_throw) {
      reject(err)
    } else if (config.errHandleType === ErrHandleType.nodeal_nothrow) {
      resolve(err)
    } else {
      // 默认处理方式，deal_throw，即统一处理、抛出异常给业务
      FetchEntregaClient.dealErrCode(err)
      reject(err)
    }
  }

  static dealErrCode = err => {
    /** todo-jqy 错误统一处理还没做，有需要了再做吧 */
    console.log(err.errmsg)
  };
}
export const ErrHandleType = {
  deal_throw: 1, // 统一处理， 抛出异常
  deal_nothrow: 2, // 统一处理， 不抛出异常
  nodeal_throw: 3, // 不统一处理，抛出异常
  nodeal_nothrow: 4 // 不统一处理，不抛出异常
}
